import React, { useEffect, useRef, useState } from "react"
import { useLocation } from '@reach/router'
import Flink from '~/components/shared/flink'
import { useTheme }  from '~/contexts/ThemeContext'
import { notBlank, jnstyls} from '~/utils/helpers'

import { Overlay, Captions } from './wraps'
import HomeImg from './home-img'

import * as styles from "~/styles/home/hero.module.scss"


const check_img = (image) => {
  return notBlank(image.image) || notBlank(image.mobile_image) ||  notBlank(image.mobile_vid_handle) || notBlank(image.vid_handle)
}

const Hero = ({ block, index }) => {
  const location = useLocation()
  const { pageLoad } = useTheme()
  const { type, is_main, images, captions } = block
  
  const [isPreview, setIsPreview] = useState(false)
  const blockRef = useRef(null)

  const has_capts = captions.length && captions.map( x => x.contents && x.contents.length > 0).includes(true) 
  const use_link = notBlank(block.url) && !block.vid_controls


  useEffect(() => {
    if (location.pathname.includes('/preview/')) setIsPreview(true)
  }, [])

  useEffect(() => {
    if (!(pageLoad && blockRef.current)) return
    blockRef.current.style.minHeight = null
  }, [pageLoad])
  
  return (
    <div 
      className={jnstyls([`${type === 'hero' ? styles.hero : styles.wide}`,`${!is_main ? styles.notmain : ''}`,`${block.first ? styles.first : ''}`])}
      ref={blockRef} 
      om={block.only_mobi ? '' : undefined} 
      g={block.gender}
      mok-block={index}
      mid={block.id}
      style={{minHeight: '60vh'}}
    >
      {use_link ? (
        <Flink href={block.url}>
          <ImgBlock block={block} index={index} isPreview={isPreview} />
        </Flink>
      ) : (
        <ImgBlock block={block} index={index} isPreview={isPreview} />
      )}

      {!!has_capts && (
        <Captions 
          block={block} 
          item={captions} 
          is_text={false} 
          index={index} 
          pstyles={styles}
        />
      )}
    </div>
  )
}


const ImgBlock = ({ block, index, isPreview }) => {
  const { images, overlays } = block

  const image = check_img(images[0])
  const has_overs = overlays.length && overlays.map( x => x.contents && x.contents.length > 0).includes(true) 

  return (
    <div className={styles.content}>
      <HomeImg item={images[0]} show_mobile={true} index={index} block={block} />
      {!!has_overs && (
        <div className={jnstyls([styles.over_cont,`overlay${block.id}`])}>
          {overlays.map((overlay, overlayIndex) =>
            <Overlay 
              key={`overlay${overlayIndex}`} 
              block={block} 
              item={overlay} 
              index={index} 
              pstyles={styles}
            />
          )}
        </div>
      )}
    </div>
  )
}




export default Hero



